import React from 'react';
import { HoldingIcon, IntegerValue } from '../../common';
import GrowthTypes from '@/types/growth-types';
import { DEFAULT_TARGET_COLOR, DEFAULT_COMPARISON_ITEM_COLOR } from '@/utils/colors';
import { COMPARISON_ITEM_TYPES, TIME_PERIODS } from '@/utils/constants';
import { formatLocalizedString, formatMessage } from '@/utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import Nullable from '@/types/nullable';

type Props = {
  targetROI?: number;
  targetName?: string;
  items: ComparisonItem[];
  dateQuickRange: Nullable<TIME_PERIODS>;
};

const GrowthAnnualizedROILegend = ({ targetROI, targetName, items, dateQuickRange }: Props) => (
  <div className="growth-roi-legend">
    {targetROI != null && (
      <span className="roi-legend-item">
        <HoldingIcon color={DEFAULT_TARGET_COLOR} type={COMPARISON_ITEM_TYPES.BENCHMARK} />
        <span>
          {targetName ?? formatMessage('Common.Target')} (<IntegerValue isPercentage value={targetROI} />)
        </span>
      </span>
    )}

    {items.map(item => (
      <span key={item._id} className="roi-legend-item">
        <HoldingIcon color={DEFAULT_COMPARISON_ITEM_COLOR} type={item.type} />
        <span>
          {formatLocalizedString(item.name)} (
          {item.performance.percentGrowth && item.performance.percentGrowth[dateQuickRange as GrowthTypes] ? (
            <IntegerValue isPercentage value={item.performance.percentGrowth[dateQuickRange as GrowthTypes] ?? 0} />
          ) : (
            formatMessage('Common.NotApplicable')
          )}
          )
        </span>
      </span>
    ))}
  </div>
);

export default GrowthAnnualizedROILegend;
